import { Box, Button, Card, Flex, Grid,
  GridItem, Heading, Input, Text} from '@chakra-ui/react';
 import { BsPlusLg as PlusIcon } from "react-icons/bs";
 import { IoEyeOutline as EyeIcon } from "react-icons/io5";
 import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
 import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
 import {TopLink} from '../';
 import {openAtom,modalAtom, openNAtom, notificationAtom} from '../../../../context';
 import { useAtom } from 'jotai';
 import ViewSetting from '../Modal/ViewSetting';
 import apiCall from '../../../../utils/apiCall';
 import { useMutation, useQuery, useQueryClient } from 'react-query';
 import { Formik, Field, Form } from "formik";
 import * as Yup from 'yup';
 import ReactPaginate from 'react-paginate';
 import { useState ,useEffect} from "react";
import styled from '@emotion/styled';
import { Loader } from '../../../../customs';

 
 type GradeDataType ={
   Id:number,
   GradeName:string;
   MaxScore:string;
   MinScore:string;
   Remarks?:string;
 }
 
 
 const list: GradeDataType [] = [
   {
     Id:1,
     GradeName:'Grade 1',
     MinScore:'30',
     MaxScore:'100',
   },
   {
    Id:2,
    GradeName:'Grade 1',
    MinScore:'30',
    MaxScore:'100',
   },
   {Id:3,
    GradeName:'Grade 1',
    MinScore:'30',
    MaxScore:'100',
   },
   {
    Id:1,
    GradeName:'Grade 1',
    MinScore:'30',
    MaxScore:'100',
   }
 ]
 
 
 const GradeScore = () => {
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [, set_n_open] = useAtom(notificationAtom);
  const [, set_notification] = useAtom(notificationAtom);
  
  const { data: gradeList} = useQuery(['grade-score'], {
    queryFn: async () => await apiCall().get(`/exam/setup/gradeScore`),
    select(data) {
      return data.data.Data;
    },
  });

  const [filter_data, set_filter_data] = useState<any>(gradeList);
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    set_filter_data(gradeList);
  }, [gradeList]);

  const queryClient = useQueryClient();
  const { mutate: deleteGradeScore, isLoading } = useMutation({
    mutationKey: ['delete-grade-score'],
    mutationFn: async (Id: number) => {
      return await apiCall().get(`/exam/setup/gradeScore/${Id}/delete`);
    },
    onSuccess: (data: any) => {
      // Show success notification
      set_notification({
        type: 'success',
        message: data.data.Message || 'Grade Score deleted successfully',
      });
      set_n_open(true);
      
      queryClient.invalidateQueries({
        queryKey: ['grade-score'],
      });
      
      set_open(false);
    },
    onError(error: any) {
      set_notification({
        type: 'error',
        message: error.data.Message || 'Error occurred during deletion',
      });
      set_n_open(true);
    },
  });
  

  const openAdd = (grade: GradeDataType | any) => {
    set_modal({
      header: grade.Id ? 'Update Grade-Score' : 'Create Grade-Score',
      content: <AddType {...grade} />,
    });
    set_open(true);
  };

  const handleDelete = (Id: number) => {
    set_modal({
      header: 'Delete GradeScore',
      content: (
        <Grid gap="20px">
          <GridItem>Are you sure you want to delete this GradeScore?</GridItem>
          <GridItem as={Flex} justify="space-between" p="20px 0">
            <Button
              disabled={isLoading}
              onClick={() => deleteGradeScore(Id)}
              bg="var(--dark-green-color)"
              color="var(--white-color)"
            >
              {isLoading ? 'Loading' : 'Delete'}
            </Button>
            <Button
              disabled={isLoading}
              variant="outline"
              bg="var(--white-color)"
              onClick={() => set_open(false)}
              border="1px solid var(--dark-green-color)"
              color="var(--dark-green-color)"
            >
              Cancel
            </Button>
          </GridItem>
        </Grid>
      ),
    });
    set_open(true);
  };

  const openView = (grade: GradeDataType) => {
    set_modal({
      header: 'View Grade & Score',
      content: <ViewType grade={grade} />,
    });
    set_open(true);
  };

  return (
    <>
     {isLoading?<Loader />:
    <Box>
      <TopLink />
      <Flex justify="space-between" align="center" mt="20px">
        <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">
          Grade & Score Setup
        </Heading>
        <Button
          bg="var(--dark-green-color)"
          color="var(--white-color)"
          onClick={() => openAdd({})}
          leftIcon={<PlusIcon />}
        >
          Add Grade
        </Button>
      </Flex>
      <Flex mt="25px" flexDir="column" gap="10px">
        <Heading m="0" fontSize="1rem">
          All Grades & Scores
        </Heading>
        <Text m="0" fontSize=".8rem">
          Showing {itemOffset} -{' '}
          {itemOffset + itemsPerPage > filter_data?.length
            ? filter_data?.length
            : endOffset}{' '}
          of {filter_data?.length}
        </Text>
      </Flex>
      <Grid templateColumns={'repeat(1,.6fr)'} gap="20px" mt="20px">
        {gradeList && gradeList.length > 0
          ? gradeList.map(({ Id, GradeName, MaxScore, MinScore, Remarks }: any) => (
              <Card key={Id} as={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row">
        <Flex flexDir="column" gap="3px">
          <Text m="0" fontWeight="bold">Grade: {GradeName}</Text>
          <Text m="0" color="red" fontWeight="bold">
            Min.Score: {MinScore}
          </Text>
          <Text m="0" color="green" fontWeight="bold">
            Max.Score: {MaxScore}
          </Text>
        </Flex>
                <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem">
                  <EyeIcon onClick={() => openView({ Id, GradeName, MaxScore, MinScore, Remarks })} style={{ cursor: 'pointer' }} />
                  <EditIcon onClick={() => openAdd({ Id, GradeName, MaxScore, MinScore, Remarks })} style={{ cursor: 'pointer' }} />
                  <DeleteIcon onClick={() => handleDelete(Id)} style={{ cursor: 'pointer' }} />
                </Flex>
              </Card>
            ))
          : ''}
      </Grid>
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />
      </StylePaginateBox>
    </Box>
 }
    </>
  );
};

 const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`
 
 export default GradeScore;
 
 const ViewType = (props:any) =>{
   const grade = props.grade;
   return (
     <ViewSetting >
       <Flex width="100%" justify="space-between" as={GridItem}>
         <span> Grade</span> {grade?.GradeName}</Flex>
       <Flex width="100%" justify="space-between" color="var(--green-color)" as={GridItem}>
         <span>Min. score</span> {grade?.MinScore}</Flex>
         <Flex color="var(--red-color)" width="100%" justify="space-between" as={GridItem}>
         <span>Max. score</span> {grade?.MaxScore}</Flex>
         <Flex color="var(--red-color)" width="100%" justify="space-between" as={GridItem}>
         <span>Remarks</span> {grade?.Remarks}</Flex>

     </ViewSetting>
   )
 }

 const AddScheme = Yup.object().shape({
  GradeName: Yup.string().required(),
  MaxScore: Yup.number().required(),
  MinScore:Yup.number().required(),
  Remarks:Yup.string().required(),
 })
 
 const AddType = (props:any) =>{
   const queryClient = useQueryClient();
   const [,set_open] = useAtom(openAtom);
   const [,set_n_open] = useAtom(openNAtom);
   const [,set_notification] = useAtom(notificationAtom);
   const {mutate:addUpdate,isLoading} = useMutation({
     mutationKey:['new-grade-score'],
     mutationFn:async (data:any)=> {
       return props && props.Id?await apiCall().put(`/exam/setup/gradeScore/${props.Id}`,data):await apiCall().post(`/exam/setup/gradeScore`,data)},
     onSuccess:(data:any)=>{
       //console.log(data)
       set_notification({
        type:'success',
        message:data.data.Message || 'Added Successfully'
       })
       set_n_open(true);

       queryClient.invalidateQueries({
         queryKey:['grade-score']
       })
     },
     onError:(error:any)=>{
      set_notification({
        type:'error',
        message:error.data.Message || 'Error Occured'
       })
       set_n_open(true);
     },
     onSettled:()=>{
       set_open(false);
     }
   } )
   return (
     <>
       <Formik
           initialValues={{
             GradeName:props.GradeName || '',
             MinScore:props.MinScore || '',
             MaxScore:props.MaxScore || '',
             Remarks:props.Remarks || '',
           }}
           validationSchema={AddScheme}
           onSubmit={(values:any) => {
            const data = {
              GradeName:values.GradeName,
              MinScore:values.MinScore,
              MaxSCore:values.MaxScore,
              Remarks:values.Remarks,
            };
             addUpdate(data)
           }}
         >
           {({ errors }) => (
             <Form>
               <Flex flexDir={"column"} align={"center"} gap="20px">
                 <Field
                   as={Input}
                   type="text"
                   name="GradeName"
                   placeholder="Grade name"
                 />
                    <Field
                   as={Input}
                   type="Number"
                   name="MinScore"
                   placeholder="Min. Score"
                 />
                    <Field
                   as={Input}
                   type="number"
                   name="MaxScore"
                   placeholder="Max. socre"
                 />
                    <Field
                   as={Input}
                   type="text"
                   name="Remarks"
                   placeholder="Result remark"
                 />
                 <Button type="submit" colorScheme="green" disabled={isLoading} >
                   {isLoading?"Loading":props.Id?'Update':'Create'}
                 </Button>
               </Flex>
                 
               
             </Form>
           )}
         </Formik>
     </>
   )
 }